import React from 'react';
import Link from 'gatsby-link';
import colors from 'pubweb-react-components/dist/styles/colors';

import Heading from 'pubweb-react-components/dist/components/Typography/Heading';
import BodyCopy from 'pubweb-react-components/dist/components/Typography/BodyCopy';

import CircleArrow from '../../images/animations/CircleArrow/CircleArrow';

import LandingCardContainer from './LandingCardStyles';

import {getLinkWithQueryString} from '../../utils/urlTools';

const LandingCard = ({ children, headerText, backgroundImages, animationColor, onClick, linkUrl }) => {

    var styleProps = {
        mobileView: {
            backgroundImage: backgroundImages.mobileImage || ""
        },
        tabletView: {
            backgroundImage: backgroundImages.tabletImage || ""
        },
        desktopView: {
            backgroundImage: backgroundImages.desktopImage || ""
        },
        animationColor: animationColor
    };

    var circleArrowRef = null;

    return (
        <LandingCardContainer styleProps={styleProps}
            onMouseEnter={() => { circleArrowRef.playAnimation() }}
            onMouseLeave={() => { circleArrowRef.stopAnimation() }}
            className="landing-card">
            <Link to={getLinkWithQueryString(linkUrl)} title={headerText} onClick={onClick}>
                <div className="card-filter">
                    <div className="inner-card-container">
                        <Heading
                            headingColor={colors.wsWhite}
                            headingSize="xlarge"
                            headingTag="h1">
                            {headerText}
                        </Heading>
                        <BodyCopy
                            paragraphType="medium">
                            {children}
                        </BodyCopy>
                        <span className="view-desktop">
                            <CircleArrow ref={(circleArrow) => circleArrowRef = circleArrow} circleColor={colors.wsWhite} arrowColor={colors.wsWhite} circleAnimationColor={animationColor} backgroundColor={'rgba(0, 0, 0, 0)'} circleDiameter="61" />
                        </span>
                        <span className="view-mobile view-tablet">
                            <CircleArrow circleColor={colors.wsWhite} arrowColor={colors.wsWhite} backgroundColor={'rgba(0, 0, 0, 0)'} circleDiameter="42" />
                        </span>

                    </div>
                </div>
            </Link>
        </LandingCardContainer >
    );
}

export default LandingCard;



// WEBPACK FOOTER //
// ./src/components/LandingCard/LandingCard.js